import { ProfileStatusEnum } from '@/types/turn-enums';
import { MoveForwardCopy } from './types';

/**
 * `move_worker_forward` in the monolith only branches on `processing` and `consent`; every other
 * status falls through untouched while the endpoint still answers 200 "Worker has been forwarded".
 */
export const MOVE_FORWARD_STATUSES: string[] = [ProfileStatusEnum.Processing, ProfileStatusEnum.Consent];

export const MOVE_FORWARD_ENABLED_TOOLTIP = 'Re-checks whether the candidate can leave their current status.';

export const MOVE_FORWARD_DISABLED_TOOLTIP =
  'Only available while the candidate is in Processing or Consent. In any other status this action does nothing.';

export const MOVE_FORWARD_COPY: Record<string, MoveForwardCopy> = {
  [ProfileStatusEnum.Processing]: {
    title: 'Move this candidate out of Processing?',
    description:
      'Turn will re-check whether every background check has finished. If they all have, the candidate leaves Processing and the report is finalized, which can auto-approve them and email both the candidate and the partner. If any check is still running, nothing changes.',
  },
  [ProfileStatusEnum.Consent]: {
    title: 'Move this candidate out of Consent?',
    description:
      'Turn will try to advance the candidate to Pending without waiting for them to assent. When the partner allows it, this records an automatic assent, sends the completed report email and consent PDF, and can auto-approve the candidate. This cannot be undone here.',
  },
};

export const MOVE_FORWARD_FALLBACK_COPY: MoveForwardCopy = {
  title: 'Move this candidate forward?',
  description:
    'This action only advances candidates in Processing or Consent. In the current status nothing will change.',
};
